import { memo, useEffect, useState } from 'react';
import { apiService } from '../services/api';
import LoadingSpinner from '../components/LoadingSpinner';

function Pengumuman() {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState("");
    const [judul, setJudul] = useState("");
    const [deskripsi, setDeskripsi] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await apiService.getPengumuman();
                const listText = response?.data?.pengumuman?.list || '';
                const pengumuman = response?.data?.pengumuman;
                setJudul(pengumuman?.judul || "");
                setDeskripsi(pengumuman?.deskripsi || "");
    
                // Format parsing: "NAMA%KELAS;"
                const entries = listText
                .split(';') // pisahkan berdasarkan titik koma
                .map(item => item.trim()) // hilangkan spasi kosong
                .filter(item => item.length > 0); // hilangkan entri kosong

                const parsed = entries
                .map(entry => {
                    const [nama, kelas] = entry.split('%');
                    return {
                    nama: nama?.trim() || '',
                    kelas: kelas?.trim() || ''
                    };
                })
                .sort((a, b) => {   
                    // Urutkan berdasarkan kelas dulu, lalu nama
                    const kelasCompare = a.kelas.localeCompare(b.kelas, 'id', { sensitivity: 'base' });
                    if (kelasCompare !== 0) return kelasCompare;
                    return a.nama.localeCompare(b.nama, 'id', { sensitivity: 'base' });
                });

                setData(parsed);

            } catch (err) {
                console.error("Gagal mengambil pengumuman:", err);
            } finally {
                setLoading(false);
            }
        };
    
        fetchData();
    }, []);
    
    
    

    // Filter data berdasarkan input pencarian (case-insensitive)
    const filteredData = data.filter(item =>
        item.nama.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="min-h-screen bg-gray-100 lg:pt-24 pt-24 justify-center">
            <div className="max-w-4xl mx-auto text-center mb-12 lg:px-0 px-6">
                <h1 className="lg:text-4xl text-xl font-bold text-center my-2">{judul}</h1>
                <p className="text-body max-w-3xl mx-auto">{deskripsi}</p>
            </div>

            <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg lg:p-6 p-4 mb-20">
                <div className="mb-4" >
                    <input
                        type="text"
                        placeholder="Cari name.."
                        className="lg:w-[300px] w-full lg:text-base text-xs p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>

                {loading ? (
                    <div className="flex justify-center items-center h-64">
                        <LoadingSpinner size="lg" text="Memuat data..." />
                    </div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full text-left lg:text-base text-xs">
                            <thead>
                                <tr>
                                    <th className="px-4 py-2 border-b">Nama</th>
                                    <th className="px-4 py-2 border-b">Kelas</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((item, index) => (
                                        <tr key={index}>
                                            <td className="px-4 py-2 border-b">{item.nama}</td>
                                            <td className="px-4 py-2 border-b">{item.kelas}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="2" className="px-4 py-2 text-center text-gray-500">
                                            Tidak ditemukan data.
                                        </td>
                                    </tr>   
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            <div className="flex justify-center mt-6">
            <a
            href="/"
            className="text-left px-3 py-2 rounded-md lg:text-base text-sm font-medium bg-primary-600 text-white hover:bg-primary-700 transition-colors flex items-center"
          >
            🏠 Beranda
          </a>
            </div>
            </div>
        </div>
    );
}

export default memo(Pengumuman);
